import React from 'react';
import { useSchedulingContext } from '../../context';
import AppointmentDetailsPresenter from './AppointmentDetailsPresenter';

interface AppointmentDetailsWrapperProps {
  collapsableDetail?: boolean;
}

const AppointmentDetailsWrapper: React.FC<AppointmentDetailsWrapperProps> = (
  props: AppointmentDetailsWrapperProps
) => {
  const schedulingDetails = useSchedulingContext();
  return <AppointmentDetailsPresenter schedulingDetails={schedulingDetails} collapsableDetail={props.collapsableDetail} />;
};

export default AppointmentDetailsWrapper;
